import { userService } from '../../services/UserService'
import Vue from 'vue';

const state = {
    profile: {},
    status: ''
};

const getters = {
    profile: (userState) => userState.profile,
    roles: (userState) => userState.profile.Roles,

    hasRole: (state) => {
        return function (role) {

            if (state.status == 'success') {
                return state.profile.Roles.includes(role);
            }
            else {
                return false;
            }
        }
    }
};

const actions = {
    userRequest: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit('userRequest');
            userService.getMyProfile()
                .then(function (result) {
                    const profileInfo = result.data;
                    commit('userSuccess', profileInfo);

                    resolve(profileInfo);
                })
                .catch(function (errors) {
                    commit('userError');
                    dispatch('auth/authLogout', null, { root: true });

                    reject(errors);
                });
        });
    }
};

const mutations = {
    userRequest: (userState) => {
        userState.status = 'attempting request for user profile data';
    },
    userSuccess: (userState, userResp) => {
        userState.status = 'success';
        Vue.set(userState, 'profile', userResp);// add reactive properties to a nested object 
    },
    userError: (userState) => {
        userState.status = 'error';
    },
    clear: (state) => {
        state.profile = {}
        state.status = ''
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
